/**
 * The front page's words (ADR-040). Plain strings, so the front page's eager bundle pulls in
 * neither game's content: `content.test.ts` checks the facts against the real numbers
 * (Slime Wars: `WARS_LIMITS`, `CLASS_IDS`, its rules line; Survival: the lobby's `RULES_SUMMARY`).
 */
export const HOME_TEXT = Object.freeze({
  title: 'Slimez',
  tagline: 'Pick a slime game.',
  modesLabel: 'Game modes',
  footer: 'Desktop browser, keyboard and mouse',
  notice: {
    SURVIVAL_CLOSED: "Survival isn't open yet — try Slime Wars.",
  },
  wars: {
    title: 'Slime Wars',
    badge: 'New',
    pitch: 'Turn-based slime artillery. Lob it, burst it, shove them into the sea.',
    facts: ['2–8 players or bots', 'about 3 minutes a round', '10 classes'],
    cta: 'Play Slime Wars',
  },
  survival: {
    title: 'Survival',
    subtitle: 'The Preserve',
    badge: 'Coming soon',
    pitch: 'Eat. Grow. Adapt. Outgrow everything in the Preserve.',
    facts: ['2–4 players', 'real-time', 'matches up to about 40 minutes'],
    cta: 'Coming soon',
    /** What assistive technology hears for the whole (inert) card. */
    label: 'Survival — coming soon',
  },
});
